import {
  forwardRef,
  ForwardRefRenderFunction,
  MouseEventHandler,
  ComponentType
} from 'react'
import clsx from 'clsx'
import { ToastPosition } from './utils'
import styles from './Toast.module.sass'

function getPositionStyles (position = ToastPosition.CENTER) {
  if (position === ToastPosition.TOP) {
    return {
      top: '16px',
      left: '50%',
      transform: 'translate(-50%)'
    }
  } else if (position === ToastPosition.BOTTOM) {
    return {
      bottom: '16px',
      left: '50%',
      transform: 'translate(-50%)'
    }
  }

  return {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, calc(-50% - 50px))'
  }
}

export interface ToastProps {
  message?: string
  buttonText?: string | null
  onClick?: MouseEventHandler
  transitionState?: string
  position?: ToastPosition
  Component?: ComponentType<any>
  customProps?: any,
  onMouseOver: () => void
  onMouseLeave: () => void
}

const Toast: ForwardRefRenderFunction<any, ToastProps> = ({
  message = '',
  buttonText = '',
  onClick,
  transitionState,
  position,
  Component,
  customProps,
  onMouseOver,
  onMouseLeave
}, ref) => (
  <div
    ref={ref}
    className={clsx(
      styles.toast,
      styles[transitionState]
    )}
    style={getPositionStyles(position)}
    onMouseOver={onMouseOver}
    onMouseLeave={onMouseLeave}
  >
    {Component
      ? <Component {...{ message, buttonText, onClick }} {...customProps} />
      : (
        <div className={styles.toastBody}>
          <div className={styles.toastText}>{message}</div>
          {buttonText && onClick
            ? (
              <div
                className={styles.toastButton}
                onClick={onClick}>{buttonText}
              </div>
              )
            : null}
        </div>
        )
    }
  </div>
)

export default forwardRef(Toast)
